module.exports = __webpack_public_path__ + "img/unknown.cf54515a.png";